import { render, staticRenderFns } from "./cardNumber.vue?vue&type=template&id=70e601d4&scoped=true&"
import script from "./cardNumber.vue?vue&type=script&lang=js&"
export * from "./cardNumber.vue?vue&type=script&lang=js&"
import style0 from "./cardNumber.vue?vue&type=style&index=0&id=70e601d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e601d4",
  null
  
)

export default component.exports